module.exports = __webpack_public_path__ + "static/img/special-price.6d5b917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/country/special-price.png
// module id = LUOs
// module chunks = 4